import ptBr from 'apexcharts/dist/locales/pt-br.json';
import { DateActivities } from 'domain/models';
import noDataBg from 'presentation/app/assets/images/no-task.png';
import ApexChart from 'react-apexcharts';

interface IProps {
  data?: DateActivities[];
}

export const ActivitiesByDayChart = ({ data }: IProps) => {
  if (!data || data?.length === 0) {
    return (
      <div className="text-center">
        <img src={noDataBg} alt="Sem dados" height={100} width={100} />
      </div>
    );
  }

  const chartOptions = {
    chart: {
      locales: [ptBr],
      defaultLocale: 'pt-br',
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'straight',
      width: 2,
    },
    colors: ['#00E396', '#FF4560', '#FEB019'],
    markers: {
      size: 4,
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeFormatter: {
          year: 'yyyy',
          month: 'dd MMM',
          day: 'dd MMM',
          hour: 'HH:mm',
        },
      },
    },
  };

  const accomplishedActivitiesData = data.map((item) => {
    return {
      x: new Date(item.date).getTime(),
      y: item.accomplished,
    };
  });

  const lostActivitiesData = data
    ? data.map((item) => {
        return {
          x: new Date(item.date).getTime(),
          y: item.lost,
        };
      })
    : [];

  const validatedActivitiesData = data.map((item) => {
    return {
      x: new Date(item.date).getTime(),
      y: item.validated,
    };
  });

  const chartSeries = [
    {
      name: 'Realizadas',
      data: accomplishedActivitiesData,
    },
    {
      name: 'Perdidas',
      data: lostActivitiesData,
    },
    {
      name: 'Validadas',
      data: validatedActivitiesData,
    },
  ];

  return (
    <ApexChart
      type="line"
      options={chartOptions}
      height={400}
      series={chartSeries}
    />
  );
};
